"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mgrs_1 = require("./mgrs");
const mgrs = new mgrs_1.MGRS();
// export interface MGRSPosition {
//     GridZone: string;	//Zone + Band
//     //100km Suare
//     LX100: number;
//     LY100: number;
//     x: number;	//MGRS X
//     y: number;	//MGRS Y
//     x_utm: number;	//UTM X
//     y_utm: number;	//UTM Y
//     GridZoneF: string;
//     GridZoneL: number;
// }
function lonlat2mgrs_xy(lonlat) {
    let mgrs = lfwgs842MgrsED50(lonlat);
    let out = mgrs;
    out._x = mgrs.x_utm;
    out._y = mgrs.y_utm;
    return out;
}
exports.lonlat2mgrs_xy = lonlat2mgrs_xy;
function mgrs_xy2lonlat(data) {
    return xyUTMED502lfwgs84(data[0], data[1], data[2].GridZoneL);
}
exports.mgrs_xy2lonlat = mgrs_xy2lonlat;
function lfwgs842MgrsED50(lonlat) {
    let lf = mgrs.flwgs84toed50(lonlat[1], lonlat[0]);
    lf = [lf[1], lf[0], lf[2]];
    let a = mgrs.fl2EDMGRS(lf[1], lf[0]);
    return a;
}
exports.lfwgs842MgrsED50 = lfwgs842MgrsED50;
function xyUTMED502lfwgs84(x, y, GridZoneL) {
    let lf = mgrs.ED50_xy2fl(x, y, GridZoneL, 0).reverse();
    lf = mgrs.fled50towgs84(lf[1], lf[0]);
    lf = [lf[1], lf[0]];
    return lf;
}
exports.xyUTMED502lfwgs84 = xyUTMED502lfwgs84;



//////////////////
// WEBPACK FOOTER
// ./node_modules/gs-geo/dist/transform_mgrs.js
// module id = 5
// module chunks = 0